import { BRAND_NAME } from "@/lib/brand";

export default function DomainUnconnected() {
  const host = typeof window !== "undefined" ? window.location.hostname : "";
  return (
    <main className="min-h-[100dvh] flex items-center justify-center bg-stone-50 px-6" data-testid="domain-unconnected">
      <div className="max-w-md text-center">
        <p className="text-xs uppercase tracking-[0.16em] text-stone-500 mb-3">{BRAND_NAME}</p>
        <h1 className="text-2xl font-semibold text-stone-900 mb-3">This domain is not connected</h1>
        <p className="text-stone-600 leading-relaxed mb-6">
          <span className="font-mono text-sm">{host}</span> points at our servers, but it is not a verified store domain.
          Connect it from Settings → Domain on your {BRAND_NAME} dashboard.
        </p>
        <a href="https://merastartup.in/" className="text-teal-700 font-semibold hover:underline">
          Go to merastartup.in
        </a>
      </div>
    </main>
  );
}
